import {
  pathogenicVeryStrongColor,
  pathogenicModerateColor,
  benignVeryStrongColor,
  benignModerateColor,
  uncertainColor,
  unknownPathogenicityColor,
} from "../../../common/helpers/colors";

export const pathogenic = "Pathogenic";
export const likelyPathogenic = "Likely Pathogenic";
export const benign = "Benign";
export const vus = "Uncertain Significance";
export const unclassified = "Unclassified";
export const likelyBenign = "Likely Benign";
export const vusP = "Uncertain significance P";
export const vusLP = "Uncertain significance LP";
export const vusLB = "Uncertain significance LB";
export const vusB = "Uncertain significance B";
export const UNKNOWN = "Unknown";
export const NOT_APPLICABLE = "Not applicable";

export const pathogenicityIndex = {
  [pathogenic]: 0,
  [likelyPathogenic]: 1,
  "Likely pathogenic": 1,
  [vus]: 2,
  "Uncertain significance": 2,
  Uncertain: 2,
  [unclassified]: 2,
  [likelyBenign]: 3,
  "Likely benign": 3,
  [benign]: 4,
  //
  [vusP]: 5,
  [vusLP]: 6,
  [vusLB]: 7,
  [vusB]: 8,
  "": 9,
  [UNKNOWN]: 9,
  [NOT_APPLICABLE]: 10,
};

export const pathogenicityLabelsShort = [
  "P",
  "LP",
  "VUS",
  "LB",
  "B",
  "VUS/P",
  "VUS/LP",
  "VUS/LB",
  "VUS/B",
  "Unknown",
  "Not Applicable",
];
export const pathogenicityLabelsLong = [
  "Pathogenic",
  "Likely Pathogenic",
  "VUS",
  "Likely Benign",
  "Benign",
  "VUS / Pathogenic",
  "VUS / Likely Pathogenic",
  "VUS / Likely Benign",
  "VUS / Benign",
  "Unknown",
  "Not Applicable",
];

export const pathogenicityFilters = [
  "Pathogenic",
  "Likely Pathogenic",
  "VUS",
  "Likely Benign",
  "Benign",
];

export const pathogenicityFiltersCNV = [
  "Pathogenic",
  "Likely Pathogenic",
  "VUS",
  "Likely Benign",
  "Benign",
  null,
  null,
  null,
  null,
  null,
  NOT_APPLICABLE,
];

export const pathogenicityRgbInd = [0, 1, 2, 3, 4, 0, 1, 3, 4];
export const pathogenicityYScale = [0, 0.25, 0.5, 0.75, 1];

export const impactIndex = {
  nonsense: 0,
  splicejunctionloss: 1,
  exondeletion: 2,
  frameshift: 3,
  startloss: 4,
  stoploss: 5,
  missense: 6,
  inframe: 7,
  synonymous: 8,
  noncoding: 9,
};
export const impactTypeIndex = {
  exondeletion: 0,
  splicejunctionloss: 0,
  nonsense: 0,
  frameshift: 0,
  startloss: 0,
  stoploss: 0,
  missense: 6,
  inframe: 7,
  synonymous: 8,
  noncoding: 9,
};

export const impactColorIndex = {
  noncoding: 1,
  inframe: 3,
  missense: 2,
  synonymous: 4,
  stoploss: 5,
  startloss: 6,
  frameshift: 7,
  exondeletion: 8,
  splicejunctionloss: 9,
  nonsense: 10,
};

export const pathogenicityColors = [
  pathogenicVeryStrongColor,
  pathogenicModerateColor,
  uncertainColor,
  benignModerateColor,
  benignVeryStrongColor,
  pathogenicVeryStrongColor,
  pathogenicModerateColor,
  benignModerateColor,
  benignVeryStrongColor,
  unknownPathogenicityColor,
];

export const impactCategories = {
  frameshift: "Null Variant",
  nonsense: "Null Variant",
  stoploss: "Null Variant",
  startloss: "Null Variant",
  exondeletion: "Null Variant",
  splicejunctionloss: "Null Variant",
};

export const impactTypeLabels = [
  "Null Variant",
  "Null Variant",
  "Null Variant",
  "Null Variant",
  "Null Variant",
  "Null Variant",
  "Missense",
  "Inframe Indel",
  "Synonymous",
  "Non-coding",
];

export const impactLabels = [
  "Nonsense",
  "Splice Junction Loss",
  "Exon Deletion",
  "Frameshift",
  "Startloss",
  "Stoploss",
  "Missense",
  "Inframe Indel",
  "Synonymous",
  "Non-coding",
];

export const impactTypeLookup = Object.values(impactTypeIndex)
  .map((index) => ({ [index]: impactLabels[index] }))
  .reduce((a, i) => ({ ...a, ...i }));

// from index get impact key.
export const impactLookup = Object.entries(impactIndex)
  .map(([key, index]) => ({ [index]: key }))
  .reduce((a, i) => ({ ...a, ...i }));
